export const translations = {
  noTranslate: 240,
  index1: 90,
  index2: -75,
  margin: 15,
};
